module.exports = __webpack_public_path__ + "img/tp-keypal-card-zh.9865e280.png";